import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable } from "rxjs";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request.clone()).pipe(
            catchError((error: unknown) => {
                const normalizedError = this.normalizeError(error, request.url);
                if (normalizedError) {
                    throw normalizedError;
                }

                throw error;
            })
        );
    }

    private normalizeError(error: unknown, api: string): unknown {
        if (error instanceof Error) {
            return error;
        }

        if (error instanceof HttpErrorResponse) {
            return this.handleHttpError(error, api);
        }

        return error;
    }

    private handleHttpError(error: HttpErrorResponse, api: string) {
        if (error.status === 401 && this.router.url !== "/" && !api.endsWith("auth/session")) {
            this.router.navigate(["/"]);
            return null;
        }

        return error;
    }
}
